export var DATA_BY_SPONSOR = {
  finect: {
    logo: 'https://www.finect.com/v4/resources/media/images/990843afd9994222afde88ec9cf29ead-w300-png',
    font: '-1',
    fontPhone: '-2',
    rel: '',
    content: ['Ranking mejores cuentas remuneradas 2024', 'Ventajas sobre cuentas de ahorro y depósitos', 'Mejores bancos con cuentas remuneradas']
  },
  freedom24: {
    logo: 'https://www.finect.com/v4/resources/media/images/c4b3651cea624dfc932ef2fed48717ff-w300-png',
    color: '#19B037',
    withDisclaimer: true,
    rel: 'sponsored noreferrer',
    content: ['Bróker regulado por la UE que paga altos intereses', 'Gane un 3,8% del saldo de su cuenta D en euros', 'Aumente hasta el 6,4% a plazo fijo', 'Fondos asegurados por el Fondo de Compensación de Inversores'],
    disclaimer: 'Las ofertas que aparecen en este espacio son ofertas patrocinadas y, por tanto, su inclusión no responde a criterios editoriales.'
  },
  default: {
    logo: 'https://www.finect.com/v4/resources/media/images/990843afd9994222afde88ec9cf29ead-w300-png',
    font: '-1',
    fontPhone: '-2',
    rel: 'sponsored noreferrer'
  }
};